/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _MissingCacheException = require('./Exception/MissingCacheException');

var _NoFlushException = require('./Exception/NoFlushException');

var _DriverException = require('./Exception/DriverException');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Abstract driver implementation
 */
let AbstractDriver = exports.AbstractDriver = function (_Core$OOP$Interface) {
  _inherits(AbstractDriver, _Core$OOP$Interface);

  function AbstractDriver() {
    _classCallCheck(this, AbstractDriver);

    var _this = _possibleConstructorReturn(this, (AbstractDriver.__proto__ || Object.getPrototypeOf(AbstractDriver)).call(this, ['_get', '_has', '_set', '_invalidate', '_type']));

    _this._buildId = '';
    _this._namespace = '';
    _this._silent = false;
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(AbstractDriver, [{
    key: 'has',


    /**
     * @param {String} key
     * @param {Function} callback
     * @returns {AbstractDriver}
     */
    value: function has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      try {
        this._has(this._buildKey(key), callback);
      } catch (e) {
        callback(new _DriverException.DriverException(e), null);
      }

      return this;
    }

    /**
     * @param {String} key
     * @param {Function} callback
     * @returns {AbstractDriver}
     */

  }, {
    key: 'get',
    value: function get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      try {
        this.has(key, (error, result) => {
          if (error) {
            callback(new _DriverException.DriverException(error), null);

            return;
          }

          if (!result && !this._silent) {
            callback(new _MissingCacheException.MissingCacheException(key), null);

            return;
          }

          this._get(this._buildKey(key), callback);
        });
      } catch (e) {
        callback(new _DriverException.DriverException(e), null);
      }

      return this;
    }

    /**
     * @param {String} key
     * @param {*} value
     * @param {Number} ttl
     * @param {Function} callback
     * @returns {AbstractDriver}
     */

  }, {
    key: 'set',
    value: function set(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      try {
        this._set(this._buildKey(key), value, ttl, callback);
      } catch (e) {
        callback(new _DriverException.DriverException(e), null);
      }

      return this;
    }

    /**
     * @param {String} key
     * @param {Number} timeout
     * @param {Function} callback
     * @returns {AbstractDriver}
     */

  }, {
    key: 'invalidate',
    value: function invalidate(key) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

      try {
        this.has(key, (exception, result) => {
          if (exception) {
            callback(new _DriverException.DriverException(exception), null);

            return;
          }

          if (!result) {
            callback(null, true);

            return;
          }

          this._invalidate(this._buildKey(key), timeout, callback);
        });
      } catch (e) {
        callback(new _DriverException.DriverException(e), null);
      }

      return this;
    }

    /**
     * @param {Function} callback
     * @returns {AbstractDriver}
     */

  }, {
    key: 'flush',
    value: function flush() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      try {
        this._flush(callback);
      } catch (e) {
        callback(new _DriverException.DriverException(e), null);
      }

      return this;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'type',
    value: function type() {
      return this._type();
    }

    /**
     * @private
     */

  }, {
    key: '_flush',
    value: function _flush() {
      throw new _NoFlushException.NoFlushException();
    }

    /**
     * @returns {String}
     */

  }, {
    key: '_buildKey',


    /**
     * @param {String} key
     * @returns {String}
     * @private
     */
    value: function _buildKey(key) {
      return `${this._buildId}:${this._namespace}#${key}`;
    }

    /**
     * @param {String} key
     * @returns {String}
     */

  }, {
    key: '_getKeyBuildId',
    value: function _getKeyBuildId(key) {
      if (this.isDeepKey(key)) {
        let matches = key.match(/^([^:])+:/);

        return matches[1];
      }

      return null;
    }

    /**
     * @param {String} key
     * @returns {Boolean}
     */

  }, {
    key: 'isDeepKey',
    value: function isDeepKey(key) {
      return (/.+:.*#.+/.test(key)
      );
    }
  }, {
    key: 'buildId',
    get: function get() {
      return this._buildId;
    }

    /**
     * @param {String} id
     */
    ,
    set: function set(id) {
      this._buildId = id;
    }
  }, {
    key: 'namespace',
    get: function get() {
      return this._namespace;
    }

    /**
     * @param {String} ns
     */
    ,
    set: function set(ns) {
      this._namespace = ns;
    }

    /**
     * @param {Boolean} value
     */

  }, {
    key: 'silent',
    set: function set(value) {
      this._silent = value;
    }

    /**
     * @returns {Boolean}
     */
    ,
    get: function get() {
      return this._silent;
    }
  }]);

  return AbstractDriver;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/AbstractDriver.js
// module id = 65
// module chunks = 0